import AjaxForm from '@naturehouse/design-system/components/organisms/form/AjaxForm';

export default class DeleteDiscountForm extends AjaxForm {
    protected onSuccess(): void {
        window.location.reload();
    }

    protected onError(): void {
        // no need to throw an error, the user can retry
    }
}

if (!customElements.get('delete-discount-form')) {
    customElements.define('delete-discount-form', DeleteDiscountForm, {
        extends: 'form'
    });
}
